<div class="email__template">
    <div class="email__template--header">
        <!-- <span>This Update Email link has expired.</span> -->
        <span> Sorry, the link has expired!</span>
       
    </div>
    <div class="email__template--body no-data">
        <p>
            The link you received to update your account email expired.

            <!-- <span> Please try again using the update email link from application to get the new email for update
                email.</span> -->
            <span> Please try again with the new link by updating the email in the application. </span>
        </p>

    </div>
</div>